import React from 'react'
import PropTypes from 'prop-types'

import cn from 'classnames'

import Card from 'components/atoms/Card'

import './index.scss'

export default class BusinessCards extends React.Component {
  static propTypes = {
    isLoading: PropTypes.bool.isRequired,
    results: PropTypes.array.isRequired,
    city: PropTypes.string,
  }

  render () {
    const {
      city,
      isLoading,
      results,
    } = this.props
 
    return <div className={cn('list-container', {isLoading: isLoading})}>
      {isLoading && <p className="loading">Loading...</p>}
      <React.Fragment>
        {results.map( (result, i) => {
          return <Card key={result.importedListingId} result={result} count={i} city={city} />
        })}
      </React.Fragment>
    </div>
  }
}
